var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScoreboardLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1366.42 199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M320.63,32.71c28.63,0,45.8,18.13,45.8,40.08,0,15.27-7.63,25.76-19.08,31.49l45.8,61.07-.95,.95h-30.54l-.95-.95-40.08-52.48h-9.54v52.48l-.95,.95h-24.81l-.95-.95V33.66l.95-.95h35.31Zm-9.54,53.44h9.54c9.54,0,16.22-3.82,16.22-13.36s-6.68-13.36-16.22-13.36h-9.54v26.72Z",
    style: {
      fill: "#008080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.43,32.71l.95,.95v24.81l-.95,.95h-63.93v23.85h46.76l.95,.95v24.81l-.95,.95h-46.76v29.58h65.84l.95,.95v24.81l-.95,.95h-91.6l-.95-.95V33.66l.95-.95h89.7Z",
    style: {
      fill: "#008080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.45,66.1c-4.2-5.73-9.92-8.59-14.69-8.59-6.68,0-9.54,3.82-9.54,9.54,0,15.27,56.3,15.27,56.3,59.16,0,22.9-19.08,42.94-44.85,42.94-20.04,0-38.17-10.5-44.85-29.58l21.95-14.7h1.91c4.77,12.79,13.36,16.6,20.99,16.6,9.54,0,16.22-5.73,16.22-15.27,0-22.9-56.3-21.95-56.3-59.16,0-21.95,16.99-37.21,38.17-37.21,16.22,0,26.72,6.68,37.21,20.99l-20.61,15.27h-1.91Z",
    style: {
      fill: "#008080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.45,99.5c0,39.12-31.49,69.66-70.61,69.66s-70.61-30.53-70.61-69.66,31.49-69.66,70.61-69.66,70.61,30.53,70.61,69.66Zm-111.64,0c0,23.85,18.13,41.98,41.03,41.98s41.03-18.13,41.03-41.98-18.13-41.99-41.03-41.99-41.03,18.13-41.03,41.99Z",
    style: {
      fill: "#008080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.33,32.71l1.91,.95,66.79,86.83V33.66l.95-.95h24.81l.95,.95V165.34l-.95,.95h-25.76l-1.91-.95-66.79-86.83v86.83l-.95,.95h-24.81l-.95-.95V33.66l.95-.95h25.76Z",
    style: {
      fill: "#008080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.44,32.71l.95,.95,50.57,131.68-.95,.95h-29.58l-.96-.95-9.54-26.72h-47.71l-9.54,26.72-.95,.95h-29.58l-.95-.95,50.57-131.68,.95-.95h26.72Zm-28.63,79.2h30.53l-15.27-44.85-15.27,44.85Z",
    style: {
      fill: "#008080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.7,32.71l.95,.95v24.81l-.95,.95h-39.12v105.92l-.95,.95h-24.81l-.95-.95V59.42h-39.12l-.95-.95v-24.81l.95-.95h104.96Z",
    style: {
      fill: "#008080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.56,32.71l.95,.95v24.81l-.95,.95h-63.93v23.85h46.76l.95,.95v24.81l-.95,.95h-46.76v29.58h65.84l.95,.95v24.81l-.95,.95h-91.6l-.95-.95V33.66l.95-.95h89.7Z",
    style: {
      fill: "#008080"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M168.52,30.59c-.33-16.92-14.19-30.59-31.19-30.59H31.2C14,0,0,14,0,31.21v106.12c0,16.29,12.55,29.69,28.48,31.08,.33,16.92,14.19,30.59,31.19,30.59h106.12c17.21,0,31.21-14,31.21-31.21V61.67c0-16.29-12.55-29.69-28.48-31.08ZM47.5,168.53h89.82c17.21,0,31.21-14,31.21-31.21V49.79c5.41,1.25,9.47,6.1,9.47,11.88v106.12c0,6.73-5.48,12.21-12.21,12.21H59.67c-6.48,0-11.78-5.08-12.17-11.47Zm102.03-64.15c-22.99,3.99-41.16,22.16-45.15,45.15h-18.7c4.28-33.2,30.64-59.57,63.85-63.85v18.7Zm0,19.12v13.82c0,6.73-5.48,12.21-12.21,12.21h-13.82c3.39-12.66,13.37-22.64,26.03-26.03Zm0-76.36v19.7c-43.53,4.45-78.24,39.16-82.7,82.69h-19.7c4.58-54.36,48.03-97.81,102.39-102.39ZM19,137.33V31.21c0-6.73,5.47-12.21,12.2-12.21h106.12c5.76,0,10.59,4.02,11.86,9.41-64.4,4.81-115.98,56.39-120.78,120.79-5.38-1.27-9.4-6.1-9.4-11.87Z",
    style: {
      fill: "#008080"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoreboardLogo);
export default __webpack_public_path__ + "static/media/scoreboard-logo.0ca06c9923712487014737a9fe7939d0.svg";
export { ForwardRef as ReactComponent };